module.exports = __webpack_public_path__ + "static/media/3.0a075f4d.jpg";